import { inject, Injectable } from '@angular/core';
import { Interstitial } from '../../models/interstitial.interfaces';

import { SwitchingAccountDisplay } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  checkStringValueNull,
  getAuxiliaryNavigation,
  HeaderFooterMachCore,
  INTERSTITIAL_BANNER,
  InterstitialBannerAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { USER_INFO } from '../../models/profile-selector.interface';
import { SwitchingAccountService } from '../../services/switching-account/switching-account.service';

@Injectable({
  providedIn: 'root'
})
export class InterstitialAdapterService {
  interstitialObject: Interstitial = {} as Interstitial;
  showDisplay = false;
  switchingAccount = inject(SwitchingAccountService);

  getContent(
    content: HeaderFooterMachCore,
    isDesktop: boolean
  ): SwitchingAccountDisplay {
    const deconstruct = this.deconstruct(content);
    this.isDisplay();
    this.interstitialObject = { ...this.interstitialObject, ...deconstruct };
    return {
      backgroundImage: this.getBackgroundImage(isDesktop),
      progressImageUrl: this.interstitialObject.progressImageUrl,
      switchingAccountText: this.getSwitchingAccountText(),
      businessLogo: this.interstitialObject.businessLogo,
      display: this.showDisplay
    };
  }

  deconstruct(content: HeaderFooterMachCore): Interstitial {
    const interstitialBanner = getAuxiliaryNavigation(
      content,
      INTERSTITIAL_BANNER
    ) as InterstitialBannerAem;

    if (interstitialBanner) {
      return {
        id: interstitialBanner.id,
        businessLogo: checkStringValueNull(interstitialBanner.businessLogo),
        acSwitchText: checkStringValueNull(interstitialBanner.acSwitchText),
        acSwitchGenericText: checkStringValueNull(
          interstitialBanner.acSwitchGenericText
        ),
        progressImageUrl: checkStringValueNull(
          interstitialBanner.progressImageUrl
        ),
        imageList: interstitialBanner.imageList ?? []
      };
    }
    return {} as Interstitial;
  }

  getBackgroundImage(isDesktop: boolean): string {
    if (this.interstitialObject && this.interstitialObject.imageList.length) {
      return isDesktop
        ? this.interstitialObject.imageList[
            Math.floor(Math.random() * this.interstitialObject.imageList.length)
          ].deskImage
        : this.interstitialObject.imageList[
            Math.floor(Math.random() * this.interstitialObject.imageList.length)
          ].mobileImage;
    }
    return '';
  }

  getSwitchingAccountText(): string {
    const info: USER_INFO = this.switchingAccount.getUserInfo();

    if (info.businessAccountOptionsLists.isOaSmeAccount) {
      return this.interstitialObject.acSwitchGenericText;
    } else {
      return this.interstitialObject.acSwitchText
        ? this.interstitialObject.acSwitchText.replace(
            '{{CNAME}}',
            this.switchingAccount.displayCorporateName
          )
        : '';
    }
  }

  isDisplay(): void {
    this.switchingAccount.displayBody.subscribe((value) => {
      if (value) {
        this.showDisplay = true;
      } else {
        this.showDisplay = false;
      }
    });
  }
}
